<div
  class="comparison-container"
  [class.is-locked]="isLocked">
  <div class="scroll-wrapper">
    <div class="career-stream-level-container">
      <div class="item">
        <p class="title bold">
          <mat-icon>work</mat-icon>
          {{ 'mercer-support.dialog.career-stream' | translate }}
        </p>
        <p>{{ 'mercer-support.dialog.career-stream-description' | translate }}</p>
        @if (currentMercerData?.careerStream && !hideCareerStreamAndLevel) {
          <p class="value defined bold">{{ currentMercerData?.careerStream }}</p>
        } @else {
          <p class="value undefined bold">{{ 'mercer-support.dialog.no-results-yet' | translate }}</p>
        }
      </div>
      <div class="item">
        <p class="title bold">
          <mat-icon>signal_cellular_alt</mat-icon>
          {{ 'mercer-support.dialog.career-level' | translate }}
        </p>
        <p>{{ 'mercer-support.dialog.career-level-description' | translate }}</p>
        @if (currentMercerData?.careerLevel && !hideCareerStreamAndLevel) {
          <p class="value defined bold">{{ currentMercerData?.careerLevel }}</p>
        } @else {
          <p class="value undefined bold">{{ 'mercer-support.dialog.no-results-yet' | translate }}</p>
        }
      </div>
    </div>

    <div class="pc-comparison-container">
      @if (dialogType === MercerDialogType.Headcount) {
        <coin-c-directs-position-comparison-list
          [comparisonEmployees]="$any(relatedPositions)"></coin-c-directs-position-comparison-list>
      } @else {
        <coin-c-position-comparisation-filter-list
          [isLocked]="isLocked"
          [lazyLoadFn]="lazyLoadFn"
          [dialogType]="dialogType"
          [relatedPositions]="relatedPositions"
          [selectedOrgLevel]="selectedOrgLevel"
          [selectedOrgCode]="selectedOrgCode"
          [isReadOnly]="mercerSupportDetailsService.isReadOnly"
          (openPosition)="openPosition.emit($event)"
          (updateRelatedPositions)="updateRelatedPositions(false)"></coin-c-position-comparisation-filter-list>
      }
    </div>
  </div>
</div>
